import { Stack, Typography, Skeleton } from '@mui/material';
import { MetricValueComparison } from '../detail/detailView/widgets/metrics/MetricValueComparison';
import { getRangesWithDefault } from '../detail/detailView/widgets/metrics/metricRange';
import { ContentMetric, useContentMetric } from '../useContentMetric';
import { useJourneyFilters } from '../useJourneyFilters';
import { metricFormatValue } from '../utils/metricFormatValue';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { getNightOrDayPalette } from '../../utils/getNightOrDayPalette';

type Props = Readonly<{
	contentMetric: ContentMetric;
	unitSign: string | null;
}>;

export const MetricRow: FC<Props> = ({ contentMetric, unitSign }) => {
	const [filters] = useJourneyFilters();
	const {
		compareRange: { start: compareStart, end: compareEnd },
		targetRange: { start: targetStart, end: targetEnd },
	} = getRangesWithDefault(filters.date);

	const { data, isLoading } = useContentMetric({ contentMetric, compareStart, compareEnd, targetStart, targetEnd });

	return isLoading ? (
		<Skeleton height={40} width={'100%'} />
	) : (
		<Stack direction={'row'} gap={1}>
			<Stack flexGrow={1} direction={'row'} gap={1} alignItems={'center'}>
				<Typography
					fontWeight={400}
					flex={1}
					sx={{
						'-webkit-line-clamp': '2',
						display: '-webkit-box',
						'-webkit-box-orient': 'vertical',
						wordBreak: 'break-word',
						overflow: 'hidden',
					}}
				>
					{data?.displayMetric?.name}
				</Typography>
				<Typography
					color={(theme) => theme.palette[getNightOrDayPalette(theme)][500]}
					flex={'0 0 auto'}
					sx={{ '&:before': { content: '"("' }, '&:after': { content: '")"' } }}
				>
					{contentMetric.activities?.map((activity: any) => activity.name).join(', ')}
				</Typography>
			</Stack>
			<Stack flexGrow={0} direction={'row'} alignItems={'center'}>
				{data?.displayMetric?.values.targetValue != null && data.displayMetric.precision != null ? (
					<Typography fontWeight={500}>
						{metricFormatValue(data.displayMetric.values.targetValue, data.displayMetric.precision)}&nbsp;{unitSign}
					</Typography>
				) : (
					<Typography>
						<FormattedMessage id={'common.not-available'} />
					</Typography>
				)}
				{data?.displayMetric != null && <MetricValueComparison metric={data.displayMetric} />}
			</Stack>
		</Stack>
	);
};
